module.exports = __webpack_public_path__ + "static/pic01-69ffb7126c214c09671f7b8d0807e647.jpg";